import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/header/Header";
import ListCard from "../../components/listCard/ListCard";
import FadeInAnimation from "../../components/animations/FadeInAnimation";
import { Button } from "../../ui";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  useFetchForumQuery,
  useFetchCollegesQuery,
  useFetchProfilesQuery,
  useFetchAllTeamsByUserQuery,
} from "../../store/api/apiSlice";
import { useForumContext } from "../../components/context/ForumContext";
import { CustomModal } from "../../components";
const ForumList = () => {
  const { data: universitiesData, isLoading, error } = useFetchCollegesQuery();

  const universities = universitiesData?.university || [];
  const schoolNameRef = useRef();
  const { data: profileData } = useFetchProfilesQuery();
  const { data: teamsdata } = useFetchAllTeamsByUserQuery(
    profileData?.user?._id
  );
  const {
    userId,
    setUserId,
    selectedForum,
    handleAllForumClick,
    setSelectedForum,
    updateSelectedSport,
    selectedSport,
    setSelectedSport,
    updateSelectedForum,
    selectedSchool,
    updateSelectedSchool,
  } = useForumContext();
  const navigate = useNavigate();
  const { data: forumData, refetch } = useFetchForumQuery();
  const [isPrivate, setIsPrivate] = useState(false);
  const [favoriteSports, setFavoriteSports] = useState([]);

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "myForum") {
      setSelectedForum("myForum");
      updateSelectedForum("myForum");
      setUserId(profileData?.user?._id);
    } else {
      setSelectedForum("viewAll");
      updateSelectedForum("viewAll");
      setUserId(null);
    }
    navigate("/forumlist");
  };
  const handleSchoolChange = (event) => {
    const selectedSchool = event.target.value;
    updateSelectedSchool(selectedSchool);
  };
  const handleSportChange = (event) => {
    const sport = event.target.value;
    setSelectedSport(sport);
    updateSelectedSport(sport);
  };
  useEffect(() => {
    if (profileData && profileData.user) {
      const { favorite_sports = [] } = profileData.user;
      const favoriteSportsData = favorite_sports[0]
        ? JSON.parse(favorite_sports[0])
        : [];
      setFavoriteSports(favoriteSportsData);
    } else {
    }
  }, [profileData]);
  const [saveButton, setSaveButton] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState("");
  const [schoolName, setSchoolName] = useState(null);
  const [description, setDescription] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [tags, setTags] = useState([]);
  const [selectedFavoriteSport, setSelectedFavoriteSport] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [favSports, setFavSports] = useState([]);
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const baseUrl = process.env.REACT_APP_SERVER_URL;
  const [forums, setForums] = useState([]);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setSaveButton(false);
    setShowModal(false);
  };

  const collegeList = universitiesData?.university || [];
  const schoolList = collegeList.map((school) => ({
    value: school._id,
    label: school.name,
  }));

  useEffect(() => {
    const fetchFavSports = async () => {
      const token = JSON.parse(localStorage.getItem("token"));
      const xAuthToken = token ? token.token : null;

      try {
        const response = await fetch(`${baseUrl}/api/sports/get-all`, {
          method: "GET",
          headers: {
            "secret-key": secretKey,
            "x-auth-token": xAuthToken,
          },
        });
        if (response.ok) {
          const data = await response.json();
          setFavSports(data.sports);
        } else {
        }
      } catch (error) {}
    };
    fetchFavSports();
  }, []);

  const handleSubmit = async (e) => {
    setSaveButton(true);
    e.preventDefault();
    const token = JSON.parse(localStorage.getItem("token"));
    const userData = JSON.parse(localStorage.getItem("user"));
    const xAuthToken = token ? token.token : null;
    const creatorId = userData ? userData._id : null;

    const payload = {
      collegeId: schoolName,
      sportsId: selectedFavoriteSport,
      creatorId: creatorId,
      tags: tags.map((tag) => tag.trim()),
      title,
      description,
      status: false,
      slug: title.toLowerCase().replace(/ /g, "-"),
      is_private: isPrivate,
      private_team: selectedTeam,
    };

    try {
      const response = await fetch(`${baseUrl}/api/forums/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "secret-key": secretKey,
          "x-auth-token": xAuthToken,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        setSaveButton(false);

        setForums((prevForums) => [...prevForums, data]);
        refetch();

        handleCloseModal();
        toast.success("Add successfully!");
      } else {
        setSaveButton(false);

        toast.error("Error creating forum");
      }
    } catch (error) {
      setSaveButton(false);

      toast.error(`Error creating forum: ${error.message}`);
    }
    setTitle("");
    setSchoolName("");
    setSelectedFavoriteSport("");
    setIsPrivate(false);
    setTags([]);
    setDescription("");
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      addTag(inputValue.trim());
      setInputValue("");
    }
  };

  const addTag = (tag) => {
    if (!tags.includes(tag)) {
      setTags((prevTags) => [...prevTags, tag]);
    }
  };

  const removeTag = (tagToRemove) => {
    setTags((prevTags) => prevTags.filter((tag) => tag !== tagToRemove));
  };

  return (
    <>
      <Header />
      <section className="Messaging_container" id="listview">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="bg-white">
                <div className="SearchContainer_forum heading_box d-flex justify-content-between align-items-center">
                  <div
                    className="ForumList_MainContainer"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <FadeInAnimation>
                      <h4
                        className="froumtitle"
                        style={{ cursor: "pointer" }}
                        onClick={handleAllForumClick}
                      >
                        Forum
                      </h4>
                    </FadeInAnimation>
                    <div className="hiddenlg">
                      <Button
                        onClick={handleShowModal}
                        className="ml-auto "
                        style={{ marginLeft: "auto", width: "max-content" }}
                      >
                        Create a Forum
                      </Button>
                    </div>
                  </div>

                  <div
                    className="SearchContainer_forum"
                    style={{
                      display: "flex",
                      gap: "10px",
                      alignItems: "flex-end",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <label>Display Forums</label>
                      <Form.Select
                       
                        placeholder="Select forum"
                        name="selectForum"
                        value={selectedForum}
                        onChange={handleSelectChange}
                      >
                        <option value="">Select Forum</option>
                        <option className="hover" value="myForum">
                          My Forum
                        </option>
                        <option className="hover" value="viewAll">
                          View All
                        </option>
                      </Form.Select>
                    </div>

                    <div style={{ width: "100%" }}>
                      <label>Schools</label>
                      <Form.Select
                        placeholder="Select school"
                        name="selectSchool"
                        value={selectedSchool}
                        onChange={handleSchoolChange}
                      >
                        <option value="">Select School</option>
                        {universities.length > 0 ? (
                          universities.map((university) => (
                            <option
                              key={university.custom_id}
                              value={university.name}
                            >
                              {university.name}
                            </option>
                          ))
                        ) : (
                          <option value="">No universities available</option>
                        )}
                      </Form.Select>
                    </div>
                    <div style={{ width: "100%" }}>
                      <label>Favorite Sports</label>
                      <Form.Select
                        placeholder="Favorite Sports"
                        name="favoriteSports"
                        value={selectedSport}
                        onChange={handleSportChange}
                      >
                        <option value="">Select Sports</option>
                        {favoriteSports.map((sport, index) => (
                          <option key={index} value={sport.name}>
                            {sport.name}
                          </option>
                        ))}
                      </Form.Select>
                    </div>

                    <div className="hiddensm">
                      <Button
                        onClick={handleShowModal}
                        className="ml-auto "
                        style={{ marginLeft: "auto", width: "max-content",padding:"6px 30px" }}
                      >
                        Create a Forum
                      </Button>
                    </div>
                  </div>
                </div>
                <ListCard
                  userId={userId}
                  selectedSchool={selectedSchool}
                  selectedSport={selectedSport}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <CustomModal isOpen={showModal} onClose={handleCloseModal}>
        <div style={{ maxWidth: "600px" }}>
          <h3>Create a Forum</h3>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="pb-4" controlId="title">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6} style={{ display: "flex", alignItems: "center" }}>
                <Select
                  options={schoolList}
                  placeholder="Select School"
                  value={
                    schoolList.find((option) => option.value === schoolName) ||
                    null
                  }
                  ref={schoolNameRef}
                  onChange={(selectedOption) => {
                    setSchoolName(selectedOption.value);
                  }}
                  styles={{
                    container: (base) => ({
                      ...base,
                      borderRadius: "5px",
                      width: "100%",
                    }),
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="pb-4 sport_select" controlId="sports">
                  <Form.Label>Sport</Form.Label>
                  <Form.Control
                    as="select"
                    value={selectedFavoriteSport}
                    onChange={(e) => setSelectedFavoriteSport(e.target.value)}
                  >
                    <option>Select a sport</option>
                    {favSports.map((sport, index) => (
                      <option key={index} value={sport._id}>
                        {sport.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="pb-4" controlId="tags">
                  <Form.Label>Tags</Form.Label>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  >
                    {tags.map((tag, index) => (
                      <span
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          margin: "2px",
                          backgroundColor: "#e0e0e0",
                          borderRadius: "3px",
                        }}
                      >
                        {tag}
                        <button
                          onClick={() => removeTag(tag)}
                          style={{
                            marginLeft: "5px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            color: "#ce1126",
                          }}
                        >
                          x
                        </button>
                      </span>
                    ))}
                    <input
                      type="text"
                      placeholder="Enter tags"
                      value={inputValue}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDown}
                      style={{
                        border: "none",
                        outline: "none",
                        flex: "1",
                        minWidth: "100px",
                        padding: "6px 18px",
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row style={{ display: "flex", alignItems: "center" }}>
              <Col md={6}>
                <Form.Group>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "20px",
                    }}
                  >
                    <input
                      type="checkbox"
                      name="IsPrivate"
                      checked={isPrivate}
                      onChange={() => setIsPrivate(!isPrivate)}
                      style={{
                        marginRight: "8px",
                        marginLeft: "8px ",
                        accentColor: "#ce1126",
                        width: "23px",
                        height: "23px",
                      }}
                    />
                    <span style={{ color: "#ce1126" }}>Make Private</span>
                  </label>
                </Form.Group>
              </Col>
              {isPrivate && (
                <Col md={6}>
                  <Form.Group className="pb-4" controlId="sports">
                    <Form.Label>Select Team</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedTeam}
                      onChange={(e) => setSelectedTeam(e.target.value)}
                    >
                      <option>Select a Team</option>
                      {teamsdata?.teams.map((team, index) => (
                        <option key={index} value={team._id}>
                          {team.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              )}
            </Row>
            <Form.Group className="pb-4" controlId="description">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>

            <Button loading={saveButton} variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </div>
      </CustomModal>
    </>
  );
};

export default ForumList;
